<template>
    <section class="columns filter-main">
        <div class="filter-content row">
            <div class="single-tab noprint mobile-full-width">
                <div class="dropdown-widget columns">
                    <div class="filter-top">
                        <div id="filterselect">
                            <div class="row">
                                <div class="small-20 columns">
                                    <label for="registers">{{ getTranslation('camp_edu_EDossierRegisterTitle') }}</label>
                                </div>
                                <div class="small-20 columns">
                                    <select id="registers" v-model="selectedRegister" class="regular-drop-down">
                                        <option v-for="register in registers" :value="register.id">
                                            {{ register.name }}
                                        </option>
                                    </select>
                                </div>
                                <div class="small-20 columns">
                                    <label for="sort">{{ getTranslation('camp_edu_EDossierOrderByTitle') }}</label>
                                </div>
                                <div class="small-20 columns">
                                    <select id="sort" v-model="selectedSort" class="regular-drop-down">
                                        <option value="date">
                                            {{ getTranslation('camp_edu_EDossierOrderByDate') }}
                                        </option>
                                        <option value="name">
                                            {{ getTranslation('camp_edu_EDossierOrderByName') }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="list-information large-20 columns">
                <div class="row">
                    <div class="small-20 columns list-information-inner tablet-column result-count" style="">
                        <strong class="count" data-count="">{{ shownDocuments.length }}</strong>
                        <span class="results-found-label">{{ getTranslation('camp_ListeResultsFound') }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="list-header row prepend-top">
            <h2 class="section-title large-20 columns nospace full-line">{{ getTranslation('camp_edu_EDossierDocumentsTitle') }}</h2>
            <label class="large-11 print-11 widget-title columns hide-for-medium-down">{{ getTranslation('camp_edu_EDossierHeaderName') }}</label>
            <label class="widget-title large-4 print-4 columns hide-for-medium-down">{{ getTranslation('camp_date') }}</label>
            <label class=" large-5 print-5 large-text-center widget-title columns hide-for-medium-down">{{ getTranslation('camp_edu_EDossierHeaderDownload') }}</label>
        </div>
        <div v-if="!loaded" class="loading-icon columns text-center prepend-top noprint">
            <p>
                <img src="/Assets/Campus/Common/img/Icons/loading-blue-50x50.gif" alt="loading..." />
            </p>
        </div>
        <div v-if="loaded && shownDocuments.length !== 0" class="row">
            <div class="filter-list-holder">
                <ul id="fl" class="nav large filter-list columns ulE-Dossier">
                    <li v-for="doc in shownDocuments" class="list-item">
                        <a :href="model.dataUrl + doc.id" class="wrap-columns" :title="doc.name">
                            <p class="columns small-12 large-11 print-11 download-text"><strong>{{ doc.name }}</strong></p>
                            <p class="columns small-8 print-5 large-5 large-push-4 text-right download-text uppercase small-no-padding nobr"><small>({{ doc.sizeStr }})</small>&nbsp;<strong>.{{ doc.fileType }}</strong>&nbsp;<i class="icon-download small-small"></i></p>
                            <p class="columns small print-4 light-text collapse large-pull-5 large-4">{{ doc.dateStr }}</p>
                        </a>
                        <div v-if="doc.remark" class="columns collapsed">
                            <p class="richtext collapse light-text">{{ doc.remark }}</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div v-if="loaded && shownDocuments.length === 0" class="row">
            <div class="filter-list-holder">
                <ul id="fl" class="nav large filter-list columns ulE-Dossier">
                    <li class="list-item noresults row">
                        <header class="tablet-column columns text-center no-outline">
                            <p><strong>{{ getTranslation('camp_edu_EDossierNoResults') }}</strong></p>
                        </header>
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>
<script>
    import MyCampusEdossier from "../../../_Api/MyCampusEdossier";

    export default {
        data() {
            return {
                "model": {
                    "dataUrl": null,
                    "translations": null
                },
                "loaded": false,
                "selectedRegister": null,
                "selectedSort": null,
                "registers": null,
                "documents": null
            }
        },
        created() {
            let data = this.$parent.$data;
            this.model = data.model;
            // default values
            this.selectedRegister = -1;
            this.selectedSort = "date";
            this.registers = [{ id: -1, name: this.getTranslation('camp_edu_EDossierRegisterAll') }];
            this.documents = [];
            // load data
            this.load();
        },
        methods: {
            load() {
                var query = null;
                MyCampusEdossier.load(query, this.loadSuccess, this.loadFailure);
            },
            getTranslation(key) {
                return this.model.translations[key];
            },
            loadSuccess(data) {
                this.registers = this.registers.concat(data.registers);
                this.documents = data.documents;
                this.loaded = true;
            },
            loadFailure(status) {
                dialogError("Es ist ein Fehler aufgetreten: Status-Code " + status);
            },
            filterDocuments(doc) {
                if (this.selectedRegister === -1) {
                    return true;
                }
                return doc.registerId === this.selectedRegister;
            },
            sortDocuments(docA, docB) {
                if (this.selectedSort === "name") {
                    return this.sortDocumentsByNameAsc(docA, docB);
                }
                return this.sortDocumentsByDateDesc(docA, docB);
            },
            sortDocumentsByNameAsc(docA, docB) {
                var num = this.compareDocumentsByNameAsc(docA, docB);
                if (num != 0) {
                    return num;
                }
                return this.compareDocumentsByDateDesc(docA, docB);
            },
            sortDocumentsByDateDesc(docA, docB) {
                var num = this.compareDocumentsByDateDesc(docA, docB);
                if (num != 0) {
                    return num;
                }
                return this.compareDocumentsByNameAsc(docA, docB);
            },
            compareDocumentsByNameAsc(docA, docB) {
                return docA.name.localeCompare(docB.name);
            },
            compareDocumentsByDateDesc(docA, docB) {
                return new Date(docB.date).getTime() - new Date(docA.date).getTime();
            }
        },
        computed: {
            shownDocuments: function () {
                return this.documents
                    .filter(this.filterDocuments)
                    .sort(this.sortDocuments);
            }
        }
    }
</script>
<style scoped lang="scss">
@import "~/Assets/Campus/Common/sass/colors";
    .dropdown-widget {
        padding: 1rem;
    }
    .regular-drop-down {
        border: 1px solid $black;
        border-radius: 0px;
        color: $black;
        background: $white;
        padding: 0.2rem 0.5rem;
        height: 2.5rem;
    }
</style>